import type { GetCampaignBriefResult } from "./types";

/**
 * Guard for the GET response. The brief is null when none is persisted;
 * otherwise it's a metadata object whose file_name (the one field the UI
 * renders) must be a string — lenient on the rest to tolerate additive drift.
 */
export const isGetCampaignBriefResult = (value: unknown): value is GetCampaignBriefResult => {
  if (value === null || typeof value !== "object") {
    return false;
  }
  const brief = (value as { brief?: unknown }).brief;
  if (brief === null || brief === undefined) {
    return true;
  }
  return typeof brief === "object" && typeof (brief as { file_name?: unknown }).file_name === "string";
};
